<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="row mb-4">
    <div class="col-6">
        <header class="d-flex align-items-center">
            @if (showBackButton) {
            <span
                class="pi pi-arrow-left me-4"
                role="button"
                style="font-size: 1.5rem; color: var(--p-primary-500)"
                (click)="onBackClick()"
            ></span>
            }
            <h2 class="headline-2">{{ title }}</h2>
            @if (showDropdownMenu) {
            <span
                class="pi pi-chevron-down ms-4"
                role="button"
                style="font-size: 1.5rem"
                (click)="onDropdownClick($event)"
            ></span>
            }
        </header>
    </div>
    <div class="col-6 d-flex align-items-center justify-content-end">
        <!-- Slot per contenuto destro (status + azioni) -->
        @if (rightContentTemplate) {
        <ng-container [ngTemplateOutlet]="rightContentTemplate"></ng-container>
        }
    </div>
</div>
